import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Inject, inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, finalize, tap } from 'rxjs/operators';
import { BaseClass } from '../../shared/class/BaseClass';
import { commonResponse } from '../../models/common';
import { ToasterService } from '../../service/toaster.service';
import { DialogServiceWrapper } from '../../service/dialog.service';
import { responseStatus } from '../constants/responseStatus.const';
import { isPlatformBrowser } from '@angular/common';
import { apiUrls } from '../constants/apiUrls.const';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class GetInterceptor extends BaseClass implements HttpInterceptor {
  private recentErrors = new Set<string>();
  private errorTimeout = 5000;
  private _toasterService = inject(ToasterService);
    private readonly ngxLoader = inject(NgxUiLoaderService);
  private dialogWrapper = inject(DialogServiceWrapper);
  constructor(  public injector: Injector,@Inject(PLATFORM_ID) private platformId: object) {
    super(injector);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<commonResponse>> {
    this.ngxLoader.start();
    return next.handle(req).pipe(
      delay(0),
      tap({
        next: (event: HttpEvent<commonResponse>) => {
          if (event instanceof HttpResponse) {
            this.handleResponse(event.body as commonResponse, req.method, req.url);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      }),
      finalize(() => {
        this.ngxLoader.stop();
      }),
    );
  }

  private handleResponse(body: commonResponse, method: string, requestUrl: string): void {
    const excludedEndpoints = [
      apiUrls.listJobs
    ];
    const shouldShowToaster = !excludedEndpoints.some(endpoint => requestUrl.includes(endpoint));
    if (body?.statusCode) {
      switch (body.statusCode) {
        case responseStatus.SUCCESS:
          if (shouldShowToaster &&
            ( method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH')) {
            this._toasterService.showSuccess(body.message);
          }
          break;
        case responseStatus.BADREQUEST:
        case responseStatus.UNAUTHORIZED:
        case responseStatus.FORBIDDEN:
        case responseStatus.REQUESTTIMEOUT:
        case responseStatus.INTERNALSERVERERROR:
          this._toasterService.showError(body.message);
          if (
            body.statusCode === responseStatus.UNAUTHORIZED ||
            body.statusCode === responseStatus.FORBIDDEN
          ) {
            this.dialogWrapper.closeDialog();
          }
          break;
        default:
          break;
      }
    }
  }

  private handleError(error: HttpErrorResponse): void {
    const errorMessage = error?.error?.message;

    if (errorMessage === 'SomethingWentWrong') {
      return;
    }

    if (!this.recentErrors.has(errorMessage)) {
      this.recentErrors.add(errorMessage);
      this._toasterService.showError(errorMessage);
      setTimeout(() => this.recentErrors.delete(errorMessage), this.errorTimeout);
    }

    if (error.status === responseStatus.UNAUTHORIZED || error.status === responseStatus.FORBIDDEN) {
      this.dialogWrapper.closeDialog();
      this.router.navigate(['/landing-page']);
      if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
      }
    }
  }
}
